var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOxyArrecadacao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 566.9",
    style: {
      enableBackground: "new 0 0 566.9 566.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#348C30;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.4,245.6c-10.3,0-18.6-8.4-18.6-18.6l0,0c0-10.3,8.4-18.6,18.6-18.6h159.3v-54.6H178.2l0,0v259.4h210.5 V245.6H229.4z M250.3,376.7h-19.8c-10.1,0-19.1-7.6-19.7-17.6c-0.6-10.8,8-19.6,18.6-19.6h19.8c10.1,0,19.1,7.6,19.7,17.6 C269.5,367.8,260.9,376.7,250.3,376.7z M250.3,320.8h-19.8c-10.1,0-19.1-7.6-19.7-17.6c-0.6-10.8,8-19.6,18.6-19.6h19.8 c10.1,0,19.1,7.6,19.7,17.6C269.5,311.9,260.9,320.8,250.3,320.8z M337.5,376.7h-19.8c-10.1,0-19.1-7.6-19.7-17.6 c-0.6-10.8,8-19.6,18.6-19.6h19.8c10.1,0,19.1,7.6,19.7,17.6C356.7,367.8,348.2,376.7,337.5,376.7z M337.5,320.8h-19.8 c-10.1,0-19.1-7.6-19.7-17.6c-0.6-10.8,8-19.6,18.6-19.6h19.8c10.1,0,19.1,7.6,19.7,17.6C356.7,311.9,348.2,320.8,337.5,320.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxyArrecadacao);
export default __webpack_public_path__ + "static/media/oxy-arrecadacao.6c296d0f88a17de0d86f6e835898c6b6.svg";
export { ForwardRef as ReactComponent };